import { ActionTree, GetterTree, Module, MutationTree } from "vuex";
import { ISupervisionTimeScheduleState } from "./types";
import { IIDAStore } from "../types";
import {
  ISupervisionTimeSchedulePost,
  ISupervisionTimeSchedulePut,
  SupervisionTimeSchedule
} from "../../models/supervisionTimeSchedules";
import { supervisionTimeScheduleService } from "../../services/SupervisionTimeSchedule.service";

export const getInitialState = (): ISupervisionTimeScheduleState => {
  return {
    supervisionTimeSchedules: []
  };
};

const namespaced = true;

export const getters: GetterTree<ISupervisionTimeScheduleState, IIDAStore> = {
  GetSupervisionTimeSchedules: (state) => {
    return state.supervisionTimeSchedules;
  },
  GetSupervisionTimeScheduleById: (state) => (id: number) => {
    return state.supervisionTimeSchedules.find((s) => s.id === id);
  }
};

export const actions: ActionTree<ISupervisionTimeScheduleState, IIDAStore> = {
  reset({ commit }) {
    commit("reset");
  },
  fetchSupervisionTimeSchedules({ commit, state }): Promise<SupervisionTimeSchedule[]> {
    return new Promise((resolve, reject) => {
      if (state.supervisionTimeSchedules.length === 0) {
        try {
          supervisionTimeScheduleService
            .fetchSupervisionTimeSchedules()
            .then((supervisionTimeSchedule) => {
              commit("updateSupervisionTimeSchedules", supervisionTimeSchedule);
              return resolve(supervisionTimeSchedule);
            });
        } catch (error) {
          return reject(error);
        }
      } else {
        const supervisionTimeSchedule = state.supervisionTimeSchedules;
        return resolve(supervisionTimeSchedule);
      }
    });
  },
  createSupervisionTimeSchedule(
    { commit },
    supervisionTimeSchedule: ISupervisionTimeSchedulePost
  ): Promise<SupervisionTimeSchedule> {
    return new Promise((resolve, reject) => {
      supervisionTimeScheduleService
        .createSupervisionTimeSchedule(supervisionTimeSchedule)
        .then((newSupervisionTimeSchedule) => {
          commit("insertSupervisionTimeSchedule", newSupervisionTimeSchedule);
          resolve(newSupervisionTimeSchedule);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateSupervisionTimeSchedule(
    { commit },
    supervisionTimeSchedule: ISupervisionTimeSchedulePut
  ): Promise<SupervisionTimeSchedule> {
    return new Promise((resolve, reject) => {
      supervisionTimeScheduleService
        .updateSupervisionTimeSchedule(supervisionTimeSchedule)
        .then((updatedSupervisionTimeSchedule) => {
          commit("updateSupervisionTimeSchedule", updatedSupervisionTimeSchedule);
          resolve(updatedSupervisionTimeSchedule);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deleteSupervisionTimeSchedule({ commit }, supervisionTimeScheduleId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      supervisionTimeScheduleService
        .deleteSupervisionTimeSchedule(supervisionTimeScheduleId)
        .then((response) => {
          commit("deleteSupervisionTimeSchedule", supervisionTimeScheduleId);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export const mutations: MutationTree<ISupervisionTimeScheduleState> = {
  reset(state: ISupervisionTimeScheduleState) {
    Object.assign(state, getInitialState());
  },
  insertSupervisionTimeSchedule(
    state: ISupervisionTimeScheduleState,
    supervisionTimeSchedule: SupervisionTimeSchedule
  ) {
    state.supervisionTimeSchedules.push(supervisionTimeSchedule);
  },
  updateSupervisionTimeSchedule(
    state: ISupervisionTimeScheduleState,
    supervisionTimeSchedule: SupervisionTimeSchedule
  ) {
    const index = state.supervisionTimeSchedules.findIndex(
      (d) => d.id === supervisionTimeSchedule.id
    );
    state.supervisionTimeSchedules.splice(index, 1);
    state.supervisionTimeSchedules.push(supervisionTimeSchedule);
  },
  deleteSupervisionTimeSchedule(
    state: ISupervisionTimeScheduleState,
    supervisionTimeScheduleId: number
  ) {
    const index = state.supervisionTimeSchedules.findIndex(
      (d) => d.id === supervisionTimeScheduleId
    );
    state.supervisionTimeSchedules.splice(index, 1);
  },
  updateSupervisionTimeSchedules(
    state: ISupervisionTimeScheduleState,
    supervisionTimeSchedules: SupervisionTimeSchedule[]
  ) {
    state.supervisionTimeSchedules = [
      ...state.supervisionTimeSchedules,
      ...supervisionTimeSchedules.filter(
        (newSupervisionTimeSchedule) =>
          !state.supervisionTimeSchedules.find((existing) =>
            existing.equals(newSupervisionTimeSchedule)
          )
      )
    ];
  }
};

export const supervisionTimeScheduleStoreModule: Module<ISupervisionTimeScheduleState, IIDAStore> =
  {
    namespaced: namespaced,
    state: getInitialState(),
    getters: getters,
    actions: actions,
    mutations: mutations
  };
